import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaLongArrowAltRight } from "react-icons/fa";
import BreadcrumbsHeader from "./breadcrumbs/BreadcrumbsHeader";
import { Link } from "react-router-dom";

const ClientsTestimonial = () => {
  

  const [videoTestimonials, setVideoTestimonials] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  
    // Fetch video testimonials
    axios
      .get("https://www.isolsgroup.com/new/api/ApiVideoTestimonial", {
        headers: { "X-API-KEY": "ISOLS" },
      })
      .then((res) => {
        // console.log("Video API Response:", res.data);
        if (res.data && Array.isArray(res.data.data)) {
          setVideoTestimonials(res.data.data);
        }
      })
      .catch((err) => console.error("Error fetching videos:", err));

    // Fetch text testimonials
    axios
      .get("https://www.isolsgroup.com/new/api/ApiTestimonial", {
        headers: { "X-API-KEY": "ISOLS" },
      })
      .then((res) => {
        // console.log("Text Testimonials Response:", res.data);
        if (res.data && Array.isArray(res.data.data)) {
          setTestimonials(res.data.data);
        }
      })
      .catch((err) => console.error("Error fetching testimonials:", err))
      .finally(() => setLoading(false));

  }, []);

  return (
    <div className="page-container">
      {/* Breadcrumbs Header */}
       <BreadcrumbsHeader 
        title="Clients Testimonial" 
        backgroundImage="/images/breadcrumbs/about-isols.jpg" 
      />

     
      {/* Videos Section */}
      <div className="videos">
        <div className="container-fluid">
          <h2 className="testii text-center">What Our Clients Say About Us</h2>
          <h4 className="testii1 text-center">Watch Clients Success Story</h4>

          {loading ? (
            <p className="text-center">Loading...</p>
          ) : videoTestimonials.length > 0 ? (
            <div className="row">
              {videoTestimonials.map((video, index) => (
                <div
                  key={index}
                  className="col-xs-12 col-sm-12 col-md-6"
                  style={{ marginBottom: "20px" }}
                >
                  <iframe
                    width="100%"
                    height="315"
                    src={video.link}
                    frameBorder="0"
                    allowFullScreen
                    title={video.name}
                  ></iframe>
                  {/* <p className="text-center mt-2">
                    <strong>{video.name}</strong>
                  </p> */}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center">No video testimonials available.</p>
          )}

          <div className="videos1 text-center" style={{ marginTop: "20px" }}>
            <a
              href="https://www.youtube.com/@ISOLSGroup/videos"
              className="btn btn-default-arrow btn-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLongArrowAltRight style={{ marginRight: "6px" }} />
              explore more
            </a>
          </div>
        </div>
      </div>
      {/* End of Page Container */}
      {/* Testimonials Section */}
     
      {/* Testimonials Section */}
<div className="b-home-testimonials testimonialsmb">
  <div className="b-testimonials1">
    <div className="container-fluid">
      <div className="row">
        <div className="col-xs-12 col-sm-12">
          <h4 className="testi">Client's Feedback</h4>
        </div>
      </div>

      {loading ? (
        <p className="text-center">Loading testimonials...</p>
      ) : testimonials.length > 0 ? (
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <div className="testimonials-holder">
              {testimonials.map((testimonial, index) => (
                <div className="testimonials-item1" key={index}>
                  <div className="testimonials-caption b-blockquote-bg b-blockquote-bg1">
                    <div className="quote-userpic img-circle">
                      <img
                        src={"https://www.isolsgroup.com/images/dummy.png"}
                        alt={testimonial.name}
                        style={{ borderRadius: "50%" }}
                      />
                    </div>
                    <div className="quote-content">
                      <p className="quote-text">{testimonial.description.replace(/<[^>]+>/g, '')}</p>
                      <p className="quote-author">
                        <span className="author-name">{testimonial.heading}</span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="videos1 text-center" style={{ marginTop: "20px" }}>
              <Link
                to="https://www.google.com/search?q=isolsgroup.com&sxsrf=AOaemvKEwpf8BbzdaNHYJE91ke01kuqcPQ%3A1636089696487&source=hp&ei=YL-EYdC1G_HErgS35a7IDw&iflsig=ALs-wAMAAAAAYYTNcNxa31Q7fBJ-ko_LniT9-A2vYxp2&oq=isolsgroup.com&gs_lcp=Cgdnd3Mtd2l6EAM6BAgjECc6CwgAEIAEELEDEIMBOgUILhCABDoICAAQgAQQsQM6BQgAEIAEOggIABCxAxCDAToRCC4QgAQQsQMQxwEQowIQkwI6CwguEIAEEMcBEKMCOg4ILhCABBCxAxDHARDRAzoECAAQCjoHCAAQgAQQCjoECC4QCjoGCAAQChAeOgoIABCABBBGEP8BOg4ILhCABBDHARCvARCTAjoHCAAQsQMQCjoECAAQDToGCAAQDRAKOgcIABCxAxANOggIABAFEAoQHjoICAAQCBAKEB5QAFjsK2DzLWgGcAB4AIAB4wGIAeYdkgEGMC4xMy43mAEAoAEB&sclient=gws-wiz&ved=0ahUKEwjQ5bWJvYD0AhVxoosKHbeyC_kQ4dUDCAc&uact=5#lrd=0x390d18946f5c854d:0xda95b0e3c86a03c5,3"
                className="btn btn-default-arrow btn-sm"
              >
                <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                Submit Your Testimonials Now
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <p className="text-center">No testimonials available.</p>
      )}
    </div>
  </div>
</div>

      {/* End of Page Container */}
    </div>
  );
};

export default ClientsTestimonial;
